<template>
    <div>
        <FormItem
            ><template #question>Shopping Cart</template>
            <template #action>
                <v-row no-gutters class="gap-2" v-if="items.length">
                    <div>
                        <v-btn
                            x-small
                            outlined
                            class="soli-round"
                            color="error"
                            @click="clearCartAlert = true"
                            >Clear Cart</v-btn
                        >
                    </div>
                </v-row></template
            >
            <template #response>
                <v-list class="pa-0">
                    <v-list-item
                        v-for="(item, idx) in items"
                        :key="item.id"
                        class="v-sheet--outlined soli-round"
                        :class="{ 'mb-3': idx < items.length - 1 }"
                    >
                        <v-list-item-content
                            class="text-align-start"
                            v-if="item.event_register"
                        >
                            <v-list-item-title class="soli-grey">
                                {{ item.product.name }}</v-list-item-title
                            >
                            <v-list-item-subtitle
                                v-if="item.event_register.details.location"
                                >{{
                                    `${item.event_register.details.location}`
                                }}</v-list-item-subtitle
                            >
                            <v-list-item-subtitle
                                v-if="item.event_register?.group_event"
                                >{{
                                    `${item.event_register.group_event.title}`
                                }}</v-list-item-subtitle
                            >
                            <v-list-item-subtitle
                                v-if="item.event_register.details.date"
                                >{{
                                    `${item.event_register.details.date}`
                                }}</v-list-item-subtitle
                            >
                            <v-list-item-subtitle
                                v-if="item.event_register.details.time"
                                >{{
                                    `${item.event_register.details.time}`
                                }}</v-list-item-subtitle
                            >
                            <v-row no-gutters v-if="false">
                                <div
                                    v-for="item in item.recipients.map(
                                        (e) => e.recipient
                                    )"
                                    :key="item.id"
                                    style="width: 24px"
                                >
                                    <v-avatar
                                        class="stacked-avatar shadow-md"
                                        size="28"
                                        ><v-img
                                            :src="item.profile_photo_url"
                                        ></v-img
                                    ></v-avatar>
                                </div>
                                <v-btn
                                    icon
                                    outlined
                                    small
                                    class="gradient-orange shadow-orange-xl white--text pa-0.5"
                                    @click="updateItem(item, item.quantity)"
                                    ><v-icon small>edit</v-icon></v-btn
                                >
                            </v-row>
                        </v-list-item-content>
                        <v-list-item-content class="text-align-start" v-else>
                            <v-list-item-title class="soli-grey">
                                {{ item.product.name }}</v-list-item-title
                            >
                            <v-list-item-subtitle>{{
                                item.product.description
                            }}</v-list-item-subtitle>
                            <v-list-item-subtitle
                                class="caption"
                                v-if="item.price.package_name"
                            >
                                {{
                                    item.price.package_name
                                }}</v-list-item-subtitle
                            >
                        </v-list-item-content>
                        <v-list-item-action class="justify-start">
                            <span class="text-lg px-1 soli-grey mb-05">
                                {{ item.price.formatAmount }}
                            </span>
                            <v-sheet outlined class="soli-round my-1">
                                <v-btn
                                    small
                                    icon
                                    color="dark"
                                    @click="updateItem(item, item.quantity - 1)"
                                    ><v-icon small>remove</v-icon></v-btn
                                >
                                <span class="px-2 soli-grey text-sm">{{
                                    item.quantity
                                }}</span>
                                <v-btn
                                    small
                                    icon
                                    color="dark"
                                    @click="updateItem(item, item.quantity + 1)"
                                    ><v-icon small>add</v-icon></v-btn
                                >
                            </v-sheet>
                            <div>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            small
                                            icon
                                            v-on="on"
                                            v-bind="attrs"
                                            v-if="item.product.contract_id"
                                            @click="
                                                item.contract_url
                                                    ? (viewContract =
                                                          item.contract_url)
                                                    : $emit('viewContract')
                                            "
                                        >
                                            <v-icon
                                                :class="[
                                                    item.contract_url
                                                        ? 'primary--text'
                                                        : 'error--text',
                                                ]"
                                                small
                                                >description</v-icon
                                            >
                                        </v-btn></template
                                    >View Agreement</v-tooltip
                                >
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            small
                                            icon
                                            color="dark"
                                            v-on="on"
                                            v-bind="attrs"
                                            @click="[$emit('delete', item)]"
                                            ><v-icon small
                                                >delete</v-icon
                                            ></v-btn
                                        ></template
                                    >Delete Item</v-tooltip
                                >
                            </div>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item v-if="!items">Such Empty</v-list-item>
                </v-list>
            </template>
        </FormItem>

        <SoliResponsiveDialog
            v-if="viewContract"
            @reset="closeModal(() => (viewContract = false))"
            ><template #body>
                <v-img contain max-height="975" :src="viewContract" />
            </template>
        </SoliResponsiveDialog>

        <SoliChoice
            v-if="clearCartAlert"
            title="Are you sure"
            subtitle="This will remove all items and event reservations in your shopping cart"
            button1="Clear Cart"
            button2="Nevermind"
            @option1="$emit('clear')"
            @reset="closeModal(() => (clearCartAlert = false))"
        />

        <!--<SoliResponsiveDialog
            v-if="editAttending"
            ref="editAttending"
            @reset="closeModal(() => (editAttending = false))"
            title="Edit Event Registration"
            subtitle="To adjust this item's quantity, select who's attending."
            ><template #body>
                <ShoppingCartEditAttending
                    :items="
                        items.map((e) => e.recipients.map((e) => e.recipient))
                    "
                    :errors="errors"
                    @success="closeModal(() => (editAttending = false))"
                />
            </template>
        </SoliResponsiveDialog>-->
    </div>
</template>

<script>
import FormItem from "../../Components/Form/FormItem.vue";
import SoliResponsiveDialog from "../Base/SoliResponsiveDialog.vue";
import ShoppingCartEditAttending from "./ShoppingCartEditAttending.vue";

export default {
    components: {
        FormItem,
        SoliResponsiveDialog,
        ShoppingCartEditAttending,
    },
    props: {
        errors: {},
        user: {
            type: Object,
            default: () => {},
        },
        guest: {
            type: Object,
            default: () => {},
        },
        items: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            editAttending: false,
            viewContract: false,
            clearCartAlert: false,
        };
    },
    methods: {
        updateItem(item, quantity) {
            this.$emit("update", {
                item: item,
                quantity: quantity,
            });
        },
    },
};
</script>
